/* eslint-disable no-useless-escape */
//import * as _ from "lodash";

import _, { add } from "lodash";
import { Component, ComponentPublicInstance } from "vue";
import { VueCookies } from "vue-cookies";
import * as setting from './webSetting';
import { parseJSON as _dt_parseJSON,format as _dt_format } from 'date-fns'



interface IalertParam{
    vue_ele:ComponentPublicInstance|null,
    title:string,
    msg:string,
}

interface INotiMsgParam{
    vue_ele:ComponentPublicInstance|null,
    msg:string,
}


interface ISetFullSizeParam{
    vue_ele:ComponentPublicInstance|null,
    is_full :boolean,
}







interface ILoadingWinParam{
    vue_ele:ComponentPublicInstance|null,
    isLoading : boolean,
    msg?:string,
}

interface ISetting{
    API_URL : string,
    WEB_Site_URL : string,
}

export interface IWebSiteMeta {
    title?: string | undefined,
    desc?: string | undefined,
    url?: string | undefined,
    image?: string | undefined,

}

export interface IImgPop {
    vue_ele:ComponentPublicInstance|null,
    "is_open": boolean,
    "img_url": string,
  }
  


interface ILoginInfo{
    guid :string,
    is_view : string,
    is_writer : string,

}

class MemberInfo{
    public is_login : boolean;
    public guid:string;
    public is_view :boolean;
    public is_writer :boolean;
    
    constructor(loginInfo:ILoginInfo|null){
        if(_.isObject(loginInfo)){
            this.is_login = true;
            this.guid = loginInfo.guid;
            this.is_view = (loginInfo.is_view == "1");
            this.is_writer = (loginInfo.is_writer == "1");
        }
        else{
            this.is_login = false;
            this.guid = "";
            this.is_view = false;
            this.is_writer = false;
        }
        
    }
}
//const allow_size_list = ["540X283","750X250","600X335","851X315","origin"];

export const UPLOAD_SIZE_STRING = {
    S_312X168: '312X168',
    S_228X144: '228X144',
    S_540X283: '540X283',
    S_750X250: '750X250',
    S_600X335: '600X335',
    S_851X315: '851X315',
    S_800X400: '800X400',
    S_origin: 'origin',
  } as const;
type UPLOAD_SIZE_STRING = typeof UPLOAD_SIZE_STRING[keyof typeof UPLOAD_SIZE_STRING];


interface IdbClickChecker{
    [key:string] : IdbClickCheckerItem,
}
interface IdbClickCheckerItem{
    time:number, //클릭한 시간..
}


export class _Util {

    private static instance: _Util;

    private _dbClickChecker:IdbClickChecker = {

    }
    
    private constructor() {
        return;
    }
    
    public static getInstance(): _Util {
        if (!_Util.instance) {
            _Util.instance = new _Util();
        }
        return _Util.instance;
    }

    public getImgURL(file_name:string,size_type:UPLOAD_SIZE_STRING){
        
        const API_URL = setting.API_URL;
        const rv = `${API_URL}/v_img/${size_type}/${file_name}`;
        return rv;
    }


    public getGUID(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    async waitTime(time: number): Promise<void> {
        return new Promise(function (rsv) {
            setTimeout(() => {
                rsv();
            }, time);
        });
    }
    public isEamilString(str :string) :boolean {
        const regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
        return regex.test(str);
    }
    //최소 8 자 30 자 이하, 하나 이상의 문자, 하나의 숫자 및 하나의 특수 문자 정규식 
    public isPasswdString(str :string) :boolean{
        const regExp = /^.*(?=^.{8,30}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&+=\(\)\<\>]).*$/;
        return regExp.test(str);
    }
    
    public alert(obj:IalertParam){
        const vue_ele = obj.vue_ele as any;
        if(vue_ele == null){
            return;
        }
        if(vue_ele.openPop == undefined){
            return;
        }
        vue_ele.openPop(obj.title,obj.msg);
    }

    public add_noti(obj:INotiMsgParam){
        const vue_ele = obj.vue_ele as any;
        if(vue_ele == null){
            return;
        }
        vue_ele.add_noti(obj.msg);
    }
    
    public setFullSize(obj:ISetFullSizeParam){
        const vue_ele = obj.vue_ele as any;
        if(vue_ele == null){
            return;
        }
        const is_full = obj.is_full;
        
        vue_ele.setFulllSize(is_full);
    }


    public openImgPop(obj:IImgPop){
        const vue_ele = obj.vue_ele as any;
        if(vue_ele == null){
            return;
        }
        vue_ele.openImgPopup(obj);
    }


    //로그인 여부 확인
    public IsLogin(cookies:VueCookies){
        if(!cookies.isKey("guid")){
            return false;
        }
        const guid = cookies.get("guid");
        if(guid == ""){
            return false;
        }
        return true;
    }

    public getLoginInfo(cookies:VueCookies){
        const is_login = this.IsLogin(cookies);

        if(is_login){
            const addData:ILoginInfo = {
                guid : cookies.get("guid"),
                is_view : cookies.get("is_view"),
                is_writer : cookies.get("is_writer")
            }
            return new MemberInfo(addData);
        }
        else{
            return new MemberInfo(null);
        }
        
    }

    public setLoading(obj:ILoadingWinParam){
        const vue_ele = obj.vue_ele as any;
        if(vue_ele == null){
            return;
        }
        vue_ele.setLoading(obj.isLoading,obj.msg);
    }


    public checkDBClick(click_id:string){
        //쓸때없는것은 항상제거..
        const limit_time = 200;
        const now = _.now();
        const remove_key:string[] = [];
        _.each(this._dbClickChecker,(obj,key)=>{
            const rest = now - obj.time;
            if(rest > limit_time){
                remove_key.push(key);
            }
        });
        //해당 키 제거..
        this._dbClickChecker = _.omit(this._dbClickChecker,remove_key);
        if(_.has(this._dbClickChecker,click_id)){
            //이미 이전에 클릭이 있었으면..
            //입력 삭제후 리턴함..
            delete this._dbClickChecker[click_id];
            return true;
        }
        else{
            const add_obj:IdbClickCheckerItem = {
                time : now,
            };
            this._dbClickChecker[click_id] = add_obj;
            return false;
        }


    }
    /**
     * 문자열에 숫자와 알파벳만 있는지 체크함
     * @param str 
     * @returns 
     */
    public isOnlyNumAlphabet(str:string){
        const engNum =  /^[a-zA-Z0-9]*$/;
        console.log(engNum.test(str));

        return engNum.test(str);
    }

    public isSeachValue(str:string){
        const engNum =  /^[a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/;
        console.log(engNum.test(str));
        return engNum.test(str);
    }

    public isSpecialWord(str:string) { 
        const regExp = /[!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\₩]/g;
        if(regExp.test(str)) {
            return true;
        }else{
            return false;
        } 
    } 
    

    public getDateJSONDate(str:string)
    {
        return _dt_parseJSON(str);
    }
    public getDateFnsForamt(){
        return _dt_format;
    }

    public getSetting():ISetting
    {
        return {
            API_URL : setting.API_URL,
            WEB_Site_URL : setting.WEB_Site_URL,
        }
    }

   

    public setMeta(d:IWebSiteMeta){

        if(d.desc != undefined){

            let ele = document.querySelector('meta[name="description"]') as HTMLElement;
            let desc = d.desc.replaceAll("\r\n"," ").replaceAll("\r"," ").replaceAll("\n"," ").replaceAll("\"","'");
            desc = desc.substring(0,150);
            ele.setAttribute("content", desc);
            ele = document.querySelector('meta[property="og:description"]') as HTMLElement;
            ele.setAttribute("content", desc);
        }
        if(d.title != undefined){
            let ele = document.querySelector('meta[name="subject"]') as HTMLElement;
            ele.setAttribute("content", d.title);
            ele = document.querySelector('meta[property="og:title"]') as HTMLElement;
            ele.setAttribute("content", d.title);
            document.title = d.title;
        }
        if(d.image != undefined){
            const ele = document.querySelector('meta[property="og:image"]') as HTMLElement;
            ele.setAttribute("content", d.image);
        }


        

       
        
    }

}



